import React, {useEffect, useState} from "react";
import "./PersonalSettings.sass";
import Window from "../../../../_containers/window/Window";
import CircleButton from "../../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TextFieldEdit from "../../../../_components/common/fields/TextFieldEdit";
import {CancelOutlined, CheckOutlined} from "@mui/icons-material";
import {useDispatch, useSelector} from "react-redux";
import {ROLE_ADMIN, ROLE_STUDENT, ROLE_TEACHER} from "../../../../common/roles";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import PhoneNumberTextEdit from "../../../../_components/common/fields/PhoneNumberTextEdit";
import {IDLE, SUCCESS} from "../../../../common/statuses";
import {getPersonalSettings, updateSettings} from "../../../../_actions/notification/notificationService";
import {
    CANCEL_LESSON,
    CHANGE_BALANCE, CHANGE_GROUP,
    CHANGE_HOMEWORK,
    CLOSE_LESSON, COLLABORATION_REQUEST, COURSE_REQUEST,
    NEXT_LESSON, RESCHEDULE_LESSON,
    SMALL_BALANCE
} from "../../../../common/notificationType";
import {useSnackbar} from "notistack";
import {updateUser, updateUserAdditional} from "../../../../_actions/auth/authService";
import {formatPhone} from "../../../../common/formater";
import {clearUpdateUser} from "../../../../_actions/auth/authReducer";
import {useNavigate} from "react-router";
import _ from "lodash"

export default function PersonalSettings() {

    const [isEditBasic, setEditBasic] = useState(false);
    const [isEditAdditional, setEditAdditional] = useState(false);

    // all
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    // student
    const [parentFullName, setParentFullName] = useState("");
    const [parentPhoneNumber, setParentPhoneNumber] = useState("");

    //teacher
    const [classAddress, setClassAddress] = useState("");
    const [paymentAccount, setPaymentAccount] = useState("");
    const [paymentReceiver, setPaymentReceiver] = useState("");
    const [bankName, setBankName] = useState("");
    const [bic, setBic] = useState("");
    const [unp, setUnp] = useState("");


    const {current: user} = useSelector(state => state.auth)
    const {status: updateStatus} = useSelector(state => state.auth.updateUser)
    const {data: settings, status: settingsStatus} = useSelector(state => state.notification.personalSettings);

    const dispatch = useDispatch();
    const navigator = useNavigate()
    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
        setFirstName(user.firstName);
        setLastName(user.lastName);
        setMiddleName(user.middleName);
        setPhoneNumber(user.phoneNumber);

        if (user.role === ROLE_STUDENT) {
            setParentFullName(user.parentFullName);
            setParentPhoneNumber(user.parentPhoneNumber);
        }

        if (user.role === ROLE_TEACHER) {
            setClassAddress(user.classAddress)
            setPaymentAccount(user.paymentAccount)
            setPaymentReceiver(user.paymentReceiver)
            setBankName(user.bankName)
            setBic(user.bic)
            setUnp(user.unp)
        }
        if (updateStatus === SUCCESS) {
            setEditBasic(false);
            setEditAdditional(false);
            enqueueSnackbar("Сохранено", {variant: "success"})
        }

    }, [user, updateStatus])
    useEffect(() => {
        if (settingsStatus === IDLE) {
            dispatch(getPersonalSettings());
        }
    }, [settingsStatus]);
    useEffect(() => {
        document.title = 'КьюАй - Настройки'
        return () => {
            dispatch(clearUpdateUser())
        }
    }, [])

    const updateHandler = () => {
        const body = {
            id: user.id,
            firstName, lastName, middleName,
            phoneNumber: phoneNumber.toString().match(/\d/g).join(""),
            role: user.role
        }
        if (user.role === ROLE_STUDENT) {
            body.parentPhoneNumber = parentPhoneNumber.toString().match(/\d/g).join("");
            body.parentFullName = parentFullName;

            dispatch(updateUser(body));
        }
    }

    const updateAdditionalHandler = () => {
        const body = {
            id: user.id,
            classAddress,
            paymentAccount,
            paymentReceiver,
            bankName,
            bic,
            unp
        }

        dispatch(updateUserAdditional(body));

    }

    const renderToggle = (settingMethod, type) => {

        const onChangeHandler = (value) => {
            if (settings[settingMethod].notificationMethod !== value) {
                const body = {...settings[settingMethod], notificationMethod: value}
                dispatch(updateSettings(body))
            }
        }

        return (
            <ToggleButtonGroup
                color="info"
                size="small"
                value={settings[settingMethod].notificationMethod}
                exclusive
                onChange={(e) => onChangeHandler(e.target.value)}
                aria-label="Platform"
            >
                {type === "ALL" && <ToggleButton value="NONE">Нет</ToggleButton>}
                <ToggleButton value="EMAIL">email</ToggleButton>
                <ToggleButton value="ACCOUNT">Профиль</ToggleButton>
                <ToggleButton value="ALL">Все</ToggleButton>
            </ToggleButtonGroup>
        )
    }

    const renderNotificationBlock = () => {
        if (user.role === ROLE_ADMIN) {
            return <>
                <b>Оповещать о новых заявках на курсы</b>
                <div className="PersonalSettings-item-main-toggle">{renderToggle(COURSE_REQUEST)}</div>

                <b>Оповещать о новых заявках на сотрудничество</b>
                <div className="PersonalSettings-item-main-toggle">{renderToggle(COLLABORATION_REQUEST)}</div>
            </>
        }
        if (user.role === ROLE_TEACHER) {
            return <>
                <b>Оповещать, если забыл завершить занятие</b>
                <div className="PersonalSettings-item-main-toggle">{renderToggle(CLOSE_LESSON)}</div>
            </>
        }
        if (user.role === ROLE_STUDENT) {
            return <>
                <b>Оповещать о наступлении отрицательного балансе</b>
                <div
                    className="PersonalSettings-item-main-toggle">{renderToggle(SMALL_BALANCE, "ALL")}</div>

                <b>Оповещать о наступающем уроке</b>
                <div
                    className="PersonalSettings-item-main-toggle">{renderToggle(NEXT_LESSON, "ALL")}</div>

                <b>Оповещать об изменении баланса</b>
                <div
                    className="PersonalSettings-item-main-toggle">{renderToggle(CHANGE_BALANCE, "ALL")}</div>

                <b>Оповещать об изменении домашнего задания</b>
                <div
                    className="PersonalSettings-item-main-toggle">{renderToggle(CHANGE_HOMEWORK, "ALL")}</div>

                <b>Оповещать о перемещении в другую группу</b>
                <div className="PersonalSettings-item-main-toggle">{renderToggle(CHANGE_GROUP)}</div>

                <b>Оповещать об отмене урока</b>
                <div className="PersonalSettings-item-main-toggle">{renderToggle(CANCEL_LESSON)}</div>

                <b>Оповещать о переносе урока</b>
                <div className="PersonalSettings-item-main-toggle">{renderToggle(RESCHEDULE_LESSON)}</div>

            </>
        }
    }

    const renderBasic = () => {
        return <div className="PersonalSettings-item-main">
            <div>Эл. почта</div>
            <b>{user.username}</b>

            <div>Фамилия</div>
            <b>{lastName}</b>

            <div>Имя</div>
            <b>{firstName}</b>

            <div>Отчество</div>
            <b>{middleName}</b>

            <div>Номер телефона</div>
            <b>{formatPhone(phoneNumber)}</b>
            {/*<b>+{parseInt(phoneNumber / 1000000000)} ({parseInt((phoneNumber / 10000000) % 100)}) {parseInt((phoneNumber / 10000) % 1000)}-{parseInt((phoneNumber / 100) % 100)}-{parseInt(phoneNumber % 100)}</b>*/}
            {/*<b>+375 (44) 752-13-59</b>*/}

            {
                user.role === ROLE_STUDENT && <>
                    <div>ФИО родителя</div>
                    <b>{parentFullName}</b>

                    <div>Номер телефона родителя</div>
                    <b>{formatPhone(parentPhoneNumber)}</b>
                </>
            }

        </div>
    }

    const renderEditableBasic = () => {
        return <div className="PersonalSettings-item-main-edit">
            <TextFieldEdit label="Эл. почта" value={user.username} disabled={true}/>
            <TextFieldEdit label="Фамилия" value={lastName} onChange={e => setLastName(e.target.value)}/>
            <TextFieldEdit label="Имя" value={firstName} onChange={e => setFirstName(e.target.value)}/>
            <TextFieldEdit label="Отчество" value={middleName} onChange={e => setMiddleName(e.target.value)}/>
            <PhoneNumberTextEdit label="Номер телефона" value={phoneNumber.toString()}
                                 onChange={e => setPhoneNumber(e.target.value)}/>

            {
                user.role === ROLE_STUDENT && <>
                    <TextFieldEdit label="ФИО родителя" value={parentFullName}
                                   onChange={e => setParentFullName(e.target.value)}/>
                    <PhoneNumberTextEdit label="Номер телефона родителя" value={parentPhoneNumber.toString()}
                                         onChange={e => setParentPhoneNumber(e.target.value)}/>
                </>
            }
        </div>
    }

    const renderAdditional = () => {

        return <div className="PersonalSettings-item-main">
            <div>Адрес проведения урока</div>
            <b>{classAddress}</b>

            <div>Счёт получателя</div>
            <b>{paymentAccount}</b>

            <div>Получатель платежа</div>
            <b>{paymentReceiver}</b>

            <div>Наименование банка</div>
            <b>{bankName}</b>

            <div>БИК</div>
            <b>{bic}</b>

            <div>УНП</div>
            <b>{unp}</b>

        </div>
    }

    const renderEducations = () => {
        const {educations} = user;
        if (!_.isEmpty(educations)) {
            return educations.map(education => {
                const {university, specialization} = education;
                return <div key={`education-${education.id}`} className="PersonalSettings-item-education">
                    <div className="PersonalSettings-item-education-university">{university}</div>
                    <div className="PersonalSettings-item-education-specialization">{specialization}</div>
                </div>
            })
        }
    }

    const renderTeacherBlock = () => {
        if (user.role === ROLE_TEACHER) {
            return <>
                <div className="PersonalSettings-item PersonalSettings-main-block-two">
                    <div className="PersonalSettings-item-header">
                        <div className="PersonalSettings-item-header-title">Дополнительная информация</div>
                        {
                            isEditAdditional ?
                                (<div className="PersonalSettings-item-header-buttons">
                                    <CheckOutlined onClick={updateAdditionalHandler}/>
                                    <CancelOutlined onClick={() => setEditAdditional(false)}/>
                                </div>) :
                                <EditOutlinedIcon onClick={() => setEditAdditional(true)}/>
                        }

                    </div>
                    {!isEditAdditional ? renderAdditional() : renderEditableAdditional()}
                </div>
                <div className="PersonalSettings-item PersonalSettings-main-block-three">
                    <div className="PersonalSettings-item-header">
                        <div className="PersonalSettings-item-header-title">Образование</div>
                    </div>
                    {renderEducations()}
                </div>
            </>
        }
    }

    const renderEditableAdditional = () => {
        return <div className="PersonalSettings-item-main-edit">
            <TextFieldEdit label="Адрес проведения урока" value={classAddress}
                           onChange={e => setClassAddress(e.target.value)}/>
            <TextFieldEdit label="Счёт получателя" value={paymentAccount}
                           onChange={e => setPaymentAccount(e.target.value)}/>
            <TextFieldEdit label="Получатель платежа" value={paymentReceiver}
                           onChange={e => setPaymentReceiver(e.target.value)}/>
            <TextFieldEdit label="Наименование банка" value={bankName} onChange={e => setBankName(e.target.value)}/>
            <TextFieldEdit label="БИК" value={bic} onChange={e => setBic(e.target.value)}/>
            <TextFieldEdit label="УНП" value={unp} onChange={e => setUnp(e.target.value)}/>

        </div>
    }

    const renderEditButtons = () => {
        if (user.role !== ROLE_STUDENT) {
            return (
                isEditBasic ?
                    (<div className="PersonalSettings-item-header-buttons">
                        <CheckOutlined onClick={updateHandler}/>
                        <CancelOutlined onClick={() => setEditBasic(false)}/>
                    </div>) :
                    <EditOutlinedIcon onClick={() => setEditBasic(true)}/>
            )
        }
    }

    return (
        <Window>
            <div className="PersonalSettings-title">
                <div className="PersonalSettings-title-text">Персональные настройки</div>
                <div>
                    <CircleButton Icon={CloseIcon} onClick={() => navigator('/home')}/>
                </div>
            </div>

            <div className="PersonalSettings-main-block">
                <div className="PersonalSettings-item PersonalSettings-main-block-one">
                    <div className="PersonalSettings-item-header">
                        <div className="PersonalSettings-item-header-title">Основная информация</div>
                        {renderEditButtons()}
                    </div>
                    {!isEditBasic ? renderBasic() : renderEditableBasic()}
                </div>
                {renderTeacherBlock()}
            </div>

            <div className="PersonalSettings-item">
                <div className="PersonalSettings-item-header">
                    <div className="PersonalSettings-item-header-title">Оповещения</div>
                </div>
                <div className="PersonalSettings-item-notification">
                    {settings && renderNotificationBlock()}
                </div>
            </div>
        </Window>
    )
}